import { addLabelArray } from "helpers/addLabelArray"
import { sgcTypes } from "./actions"

const { GET_SGC, SGC_CLEAN_STATE} = sgcTypes

const initialState = {
    sgc: []
}

export const sgcReducer = (state=initialState, { type, payload }) => {
  switch (type) {
    case GET_SGC:
      const labeling = addLabelArray(payload, 'name')
      // debugger
      return { ...state, sgc: labeling }
    case SGC_CLEAN_STATE:
      return initialState
    default:
      return state
  }
}